module.exports = __webpack_public_path__ + "static/media/debbie_writing.7662c2d4.webp";